import { Injectable } from '@angular/core';

// Notifier pluging
import { NotifierService } from 'angular-notifier';

@Injectable({ providedIn: 'root' })
export class NotifyService {

    private readonly notifier: NotifierService;

    constructor(notifierService: NotifierService) {
        this.notifier = notifierService;
    }

    // Notificaciones
    // Error login
    notifyErrIngreso(message: string) {
        this.notifier.notify('error', message);
    }

    // Error de conexión
    notifyErrServer(mensaje: string) {
        this.notifier.notify('error', mensaje);
    }

    // Error datos de formulario invalidos
    notifyErrForm() {
        this.notifier.notify('error', 'Formulario invalido, compruebe los datos');
    }

    // Success
    notifySuccForm(message: string) {
        this.notifier.notify('success', message);
    }

    // Warning
    notifyWarning(message: string) {
        this.notifier.notify('warning', message);
    }

}
